(() => {
  const media = window.matchMedia('(max-width: 749px)');

  const sync = () => {
    document.querySelectorAll('.footer-mobile-accordion').forEach((button) => {
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      if (!panel) return;
      if (media.matches) {
        const expanded = button.getAttribute('aria-expanded') === 'true';
        button.removeAttribute('tabindex');
        panel.hidden = !expanded;
      } else {
        button.setAttribute('aria-expanded', 'true');
        button.setAttribute('tabindex', '-1');
        panel.hidden = false;
      }
    });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.footer-mobile-accordion');
    if (!button || !media.matches) return;
    const panel = document.getElementById(button.getAttribute('aria-controls'));
    if (!panel) return;
    const expanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', String(!expanded));
    panel.hidden = expanded;
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync, { once: true });
  else sync();
  media.addEventListener('change', (event) => {
    if (event.matches) {
      document.querySelectorAll('.footer-mobile-accordion').forEach((button) => button.setAttribute('aria-expanded', 'false'));
    }
    sync();
  });
  document.addEventListener('shopify:section:load', sync);
})();
